import './PetAnimations.css';

/* Cada pet tem: emoji, posição X inicial, duração, delay, tamanho e direção */
const PETS = [
  { emoji: '🐾', x: 5,  duration: 18, delay: 0,   size: 28, dir: 1  },
  { emoji: '🐱', x: 15, duration: 22, delay: 3,   size: 32, dir: -1 },
  { emoji: '🐶', x: 28, duration: 16, delay: 6,   size: 30, dir: 1  },
  { emoji: '🐾', x: 42, duration: 25, delay: 1,   size: 22, dir: -1 },
  { emoji: '🐱', x: 55, duration: 20, delay: 8,   size: 34, dir: 1  },
  { emoji: '🐾', x: 68, duration: 14, delay: 4,   size: 24, dir: -1 },
  { emoji: '🐶', x: 78, duration: 23, delay: 11,  size: 28, dir: 1  },
  { emoji: '🐾', x: 88, duration: 19, delay: 2,   size: 20, dir: -1 },
  { emoji: '🐱', x: 93, duration: 17, delay: 9,   size: 26, dir: 1  },
  { emoji: '🐾', x: 35, duration: 21, delay: 14,  size: 18, dir: -1 },
  { emoji: '🐶', x: 62, duration: 15, delay: 7,   size: 32, dir: 1  },
  { emoji: '🐾', x: 50, duration: 26, delay: 5,   size: 16, dir: -1 },
];

export default function PetAnimations() {
  return (
    <div className="pets-container" aria-hidden="true">
      {PETS.map((p, i) => (
        <span
          key={i}
          className="pet-float"
          style={{
            left:            `${p.x}%`,
            fontSize:        `${p.size}px`,
            animationDuration: `${p.duration}s`,
            animationDelay:  `${p.delay}s`,
            '--dir':         p.dir,
          }}
        >
          {p.emoji}
        </span>
      ))}
    </div>
  );
}
